module.exports = __webpack_public_path__ + "img/bcid-logo-rev-en.20eebe74.svg";